// ** Initial State
const initialState = {
  dropdown: [],
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedLeaveIncrement: null
}

const leaveIncrements = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_LEAVE_INCREMENTS_DROPDOWN':
      return { ...state, dropdown: action.data }
    case 'GET_ALL_LEAVE_INCREMENTS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_LEAVE_INCREMENTS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_LEAVE_INCREMENT':
      return { ...state, selectedLeaveIncrement: action.selectedLeaveIncrement }
    case 'ADD_LEAVE_INCREMENT':
      return { ...state }
    case 'DELETE_LEAVE_INCREMENT':
      return { ...state }
    default:
      return { ...state }
  }
}
export default leaveIncrements
